import React from 'react';
import { ChevronDown, Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useOrganizationAccess } from '@/app/hooks/useOrganizationAccess';
import { cn } from '@/lib/utils';

interface OrganizationSwitcherBadgeProps {
  onClick: () => void;
}

export const OrganizationSwitcherBadge: React.FC<OrganizationSwitcherBadgeProps> = ({
  onClick,
}) => {
  const { organizations, currentOrganizationId, hasMultipleOrgs, isLoading } = useOrganizationAccess();

  // Only show if user has access to 2+ organizations
  if (!hasMultipleOrgs && !isLoading) {
    return null;
  }

  if (isLoading) {
    return <Skeleton className="h-9 w-32 rounded-full" />;
  }

  const currentOrg = organizations.find((org) => org.organization_id === currentOrganizationId);
  const orgName = currentOrg?.organization.name ?? 'Organization';

  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={cn(
        "h-9 px-3 gap-2 rounded-full",
        "bg-teal-50 hover:bg-teal-100 dark:bg-teal-900/30 dark:hover:bg-teal-900/50",
        "text-teal-700 dark:text-teal-300",
        "border border-teal-200 dark:border-teal-800",
        "transition-all duration-200"
      )}
    >
      <Building2 className="h-4 w-4" />
      <span className="text-sm font-medium max-w-[120px] truncate">
        {orgName}
      </span>
      <ChevronDown className="h-3.5 w-3.5 opacity-60" />
    </Button>
  );
};
